import { gql } from '@/__generated__';

export const GET_REPORT_TEMPLATE = gql(`#graphql
  query Reports_GetReportTemplate($id: Int!) {
    reportTemplate(id: $id) {
      id
      name
      description
      timezone
      meanWindow
      emails
      relativeTime
      createExcel
      createPdf
      metrics {
        name
        unit
      }
      devices {
        id
        profile {
          id
          name
        }
      }
      createdAt
      schedules {
        id
        recurrence
        dayOfWeek
        daysOfWeek
        hours
        minutes
      }
    }
  }
`);
